import React from "react";
import "../../Tabels/Tabels.css";
import Header from "../../Header/Header";
import BankDetails from "../App_setup/BankDetails";

import { Toaster } from "react-hot-toast";

const Tables = () => {
  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Bank Details"} link={"/masters/bank-detail"} />
        <section className="AdvanceDashboard">
          <div className="col-xxl-12 col-xl-12">
            <section className="Tabels tab-radio mt-3">
              <BankDetails />
            </section>
          </div>
        </section>
      </div>
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
